export default "__VITE_PUBLIC_ASSET__246b7a92__"